export const filterProductWarnings = (productWarnings, filter) =>
  Object.keys(productWarnings).reduce((newProductWarnings, sku) => {
    if (filter(sku)) {
      return {
        ...newProductWarnings,
        [sku]: productWarnings[sku],
      };
    }
    return newProductWarnings;
  }, {});
